import { render, staticRenderFns } from "./SelectCloseBtn.vue?vue&type=template&id=74b9413e&scoped=true&lang=pug&"
import script from "./SelectCloseBtn.vue?vue&type=script&lang=js&"
export * from "./SelectCloseBtn.vue?vue&type=script&lang=js&"
import style0 from "./SelectCloseBtn.vue?vue&type=style&index=0&id=74b9413e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b9413e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
